import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const notifySuccess = (text) => toast.success(text);
export const notifyError = (text) => toast.error(text);
export const Toast = <ToastContainer />;
